export default {
  meta: {
    title: '保护期管理',
    url: '/standardstore/protectionterm', // 埋点字段，上报归属的模块
    urlName: '保护期管理' // 埋点字段，上报归属的模块
  }
};
